// extracted by mini-css-extract-plugin
export default {"root":"styles_root__MUWea","contents":"styles_contents__FNnIF"};